import * as React from "preact";
import { FunctionComponent } from "preact";

import cx from "classnames";

export interface IMetaItem {
  name: string;
  value: string;
  block?: boolean;
}

const MetaItem: FunctionComponent<IMetaItem> = ({ name, value, block = false }) => {
  return (
    <div
      className={cx("search-results-meta__item", {
        "search-results-meta__item--inline search-results-meta__item-divider": !block,
      })}
    >
      <p className={cx("search-results-meta__item-text", { "search-results-meta__item--block": block })}>
        <span className="search-results-meta__label">{name} </span>
        <span className="search-results-meta__value">{value}</span>
      </p>
    </div>
  );
};

export default MetaItem;
